import { render } from "./consultWaitEdit.vue?vue&type=template&id=b8e8ed02&scoped=true"
import script from "./consultWaitEdit.vue?vue&type=script&lang=js"
export * from "./consultWaitEdit.vue?vue&type=script&lang=js"

import "./consultWaitEdit.vue?vue&type=style&index=0&id=b8e8ed02&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8e8ed02"]])

export default __exports__